import Keyb from "keyb"
import Joyp from "joyp"

import Random from "@fae/source/utility/Random.js"

import App from "@fae/source/models/App.js"
import Dev from "@fae/source/models/dev/Dev.js"
import Stage from "@fae/source/models/Stage.js"
import Unit from "@fae/source/models/Unit.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Selection from "@fae/source/models/Selection.js"
import Step from "@fae/source/models/Step.js"
import Delta from "@fae/source/models/Delta.js"

import Audiomix from "@fae/source/engine/Audiomix.js"
import Navigation from "@fae/source/engine/navigating/Navigation.js"

import games from "@fae/source/data/games/index.js"

import {nanoid} from "nanoid"
import querystring from "query-string"

export default class Chapter {
    static load(proto, options) {
        options = options || {}

        const chapter = new Chapter()

        chapter.decorations = proto.chapter.decorations || {}
        chapter.timer = 5 * 60 * 1000

        // RANDOMNESS
        const query = querystring.parse(window.location.search)
        const seed = query.seed || proto.randomSeed || nanoid()
        chapter.random = new Random()
        chapter.random.setSeed(seed)
        chapter.originalSeed = seed

        chapter.runningDeltastageSum = {}
        chapter.runningDeltastageSubsum = {}

        let stage = proto.chapter.stage

        if(proto.deltastageSum != undefined) {
            chapter.runningDeltastageSum = proto.deltastageSum
            stage = Delta.editStage(stage, proto.deltastageSum)
        }

        chapter.previousStages = []
        chapter.stage = Stage.load({
            "stage": stage,
            "player": proto.player,
            "chapterParty": proto.chapterParty,
            "hasPreparePhase": chapter.hasPreparePhase,
            "startingEncounter": proto.startingEncounterKey || proto.chapter.startingEncounter,
            "chapterSlug": chapter.key,
            "gameSlug": chapter.gamekey,
            "random": chapter.random,
        })

        chapter.animationSequence = options.animationSequence

        chapter.selection = new Selection({"chapter": chapter})

        // TODO: Deprecate all of these!! Most of them are already out of use.
        chapter.type = "combat"
        chapter.player = proto.player || {"affiliation": "good"}
        chapter.key = proto.chapter.key
        chapter.gamekey = proto.gamekey
        chapter.images = proto.chapter.images
        chapter.audio = proto.chapter.audio
        chapter.hasTutorial = proto.chapter.hasTutorial
        chapter.hasPreparePhase = proto.chapter.hasPreparePhase
        chapter.hasUndoEndTurnButtons = proto.chapter.hasUndoEndTurnButtons
        chapter.hasAutoEnd = proto.chapter.hasAutoEnd
        chapter.isRandomized = proto.chapter.isRandomized
        chapter.encounters = proto.chapter.encounters

        if(stage != undefined
        && options.isBlockingSideEffects != true) {
            Dev.loadedProtostage = stage
            Object.values(Dev.loadedProtostage.units).forEach((unit) => {
                Dev.cacheUnitReferredProperties({unit, "player": chapter.player, "chapterSlug": chapter.key, "gameSlug":  chapter.gamekey})
            })
        }

        if(proto.deltastageSum != undefined) {
            chapter.phase = "play"
        } else if(proto.deltastageSum == undefined) {
            if(chapter.hasPreparePhase == true) {
                chapter.phase = "prepare"
            } else {
                chapter.phase = "play"

                let steps = []
                    .concat(Stage.getEventSteps(chapter.stage, "chapter:start"))
                    .concat(Stage.getEventSteps(chapter.stage, "turn:0:start"))
                    .concat(Stage.getEventSteps(chapter.stage, "turn:every:start"))
                    .concat(Stage.getEventSteps(chapter.stage, "turn:every-even:start"))
                    // TODO: this is not respecting the omegastages of the other events!!
                    // TODO: THIS IS VERY BAD

                // if(steps.length > 0) {
                //     chapter.stage = steps.filter((step) => step.name != "SavestateCapture").pop()?.omegastage
                // }
                // steps = steps.concat(Stage.getStartOfTurnSkillSteps(chapter.stage))

                if(steps.length > 0) {
                    chapter.stage = steps.filter((step) => step.name != "SavestateCapture").pop()?.omegastage
                    chapter.animationSequence = {"steps": steps}
                    chapter.sumSteps(steps)
                    if(options.isBlockingSideEffects != true) {
                        App.sequence = {"steps": steps}
                    }
                }


                Stage.calculateActions(chapter.stage)
            }
        }

        chapter.actionTrace = []
        if(options.isBlockingSideEffects != true) {
            chapter.animationSequence = {
                "steps": []
                // .concat(Stage.getEventSteps(chapter.stage, "turn:0:start"))
                // .concat(Stage.getEventSteps(chapter.stage, "turn:every:start"))
                // .concat(Stage.getEventSteps(chapter.stage, "turn:every-even:start"))
            }
            if(chapter.animationSequence.steps != undefined
            && chapter.animationSequence.steps.length > 0) {
                chapter.sumSteps(chapter.animationSequence.steps)
                chapter.stage = chapter.animationSequence.steps[chapter.animationSequence.steps.length - 1].omegastage
            }
        }

        return chapter
    }
    // update(delta) {
    //     this.selection.update(delta)
    //
    //     if(Dev.inProtoMode == false) {
    //         if(Keyb.wasJustPressed("Z")
    //         || Joyp.wasJustPressed(0, "left-bumper", delta.ms)
    //         || Joyp.wasJustPressed(0, "right-bumper", delta.ms)) {
    //             this.actionTrace.push({"type": "undoAction"})
    //             this.undoAction()
    //             Dev.recordSavestate("livePlaytest")
    //         }
    //     }
    //
    //     if(Keyb.isPressed("<control>") && Keyb.isPressed("R")) {
    //         App.game.chapter.restart()
    //     }
    // }
    replaySavestateFromActiontrace(savestate, options) {
        options = options || {}

        for (const savedSelection of savestate.actionTrace) {
            if(savedSelection.type == "endTurn") {
                this.runningDeltastageSubsum = {}
                this.endPlayerTurn(this.stage, {"isAutocapturingSavestates": false, "seed": savedSelection.seed})

                // const deltaDiff = Delta.diffDeltastageSums(savedSelection.deltastageSum, this.runningDeltastageSubsum)
                // if(Object.values(deltaDiff).length > 0) {
                //     // console.warn("Savestate replay diverges at this action. Terminating replay at this point", savedSelection, deltaDiff)
                //     // // is blasted too many times, even when not in dev mode.
                //     return
                // }
                continue
            }
            if(savedSelection.type == "endEncounter") {
                this.runningDeltastageSubsum = {}
                this.endPlayerTurn(this.stage, {"isAutocapturingSavestates": false, "seed": savedSelection.seed})
                const steps = Stage.processEventSteps(stage, condition.events)
                this.sequence.steps = this.sequence.steps.concat(steps)
                stage = steps[steps.length - 1].omegastage
                Stage.calculateActions(stage)
                this.stage = stage
                this.sumSteps(steps)

                const deltaDiff = Delta.diffDeltastageSums(savedSelection.deltastageSum, this.runningDeltastageSubsum)
                if(Object.values(deltaDiff).length > 0) {
                    console.warn("Savestate replay diverges at this action. Terminating replay at this point", savedSelection, deltaDiff)
                    return
                }
                continue
            }
            if(savedSelection.type == "undoAction") {
                this.undoAction()
                continue
            }
            if(savedSelection.type == "killAllEnemies") {
                this.killAllEnemies()
                continue
            }

            const unit = this.stage.units[savedSelection.performerKey]
            if(unit == undefined) {
                console.warn("Terminating savestate replay. This saved action's performer no longer exists: ", savedSelection)
                this.selection.hoveredAction = savedSelection
                break
            }
            unit.actionmap = Unit.calculateActions(unit.key, this.stage)
            const actionlist = unit.actionmap[savedSelection.position.x + "x" + savedSelection.position.y]
            if(actionlist == undefined) {
                console.warn("Terminating savestate replay. This saved action's position no longer has any actions: ", savedSelection)
                this.selection.hoveredAction = savedSelection
                this.selection.selectedUnitKey = savedSelection.performerKey
                break
            }
            const subactionlist = this.selection.findSubactionsInActionlist({unit, actionlist, "options": {}})
            const indexedAction = subactionlist.filter((action) => {
                return action.type == savedSelection.type
                    && action.skillKey == savedSelection.skillKey
                    && action.omegastage.units[action.performerKey].position.x == savedSelection.performerPosition.x
                    && action.omegastage.units[action.performerKey].position.y == savedSelection.performerPosition.y
            })[0]
            if(indexedAction == undefined) {
                console.warn("Terminating savestate replay. This saved action no longer available: ", savedSelection)
                this.selection.hoveredAction = savedSelection
                this.selection.selectedUnitKey = savedSelection.performerKey
                break
            }

            if(options.isShowingEveryStep == true) {
                App.sequence = {"steps": (this.sequence?.steps || []).concat(indexedAction.steps)}
                // this.sequence = {"steps": (this.sequence?.steps || []).concat(indexedAction.steps)}
            } else {
                App.sequence = {"steps": indexedAction.steps}
                // this.sequence = {"steps": indexedAction.steps}
            }
            this.setStage(indexedAction.omegastage)
            const replayDelta = this.sumSteps(indexedAction.steps)
            const savedDelta = savedSelection.deltastageSum
            const deltaDiff = Delta.diffDeltastageSums(savedDelta, replayDelta)
            if(Object.values(deltaDiff).length > 0) {
                console.warn("Savestate replay diverges at this action. Terminating replay at this point", savedSelection, deltaDiff)
                return
            }
        }
        if(options.isShowingEveryStep == true) {
            return
        }
        // if(savestate.sequenceLengthRemaining == undefined) {
        //     App.sequence = undefined
        //     this.sequence = undefined
        // } else {
        //     const newLength = savestate.sequenceLengthRemaining
        //     if(this.sequence == undefined) {
        //         console.warn("Savestate replay error: Replay has no animated sequence to show")
        //         return
        //     }
        //     if(this.sequence.steps.length < newLength) {
        //         console.warn("Savestate replay error: Replay's animation sequence length does not match")
        //         return
        //     }
        //     this.sequence.steps = this.sequence.steps.slice(this.sequence.steps.length - newLength, this.sequence.steps.length)
        // }
    }
    restart(options) {
        options = options || {}
        this.actionTrace = []
        this.runningDeltastageSum = {}
        App.load({
            "game": {
                "key": this.gamekey,
                "player": options.player || App.game.player,
                "chapter": games[this.gamekey].chapters[App.game.chapter.key],
                "configuration": games[this.gamekey].configuration,
                "randomSeed": options.randomSeed,
                "audio": games[this.gamekey].audio, // TODO: THIS IS A MAJOR BUG!! WE SHOULD BE COPYING OVER ALL PROPERTIES FROM GAME!!
            }
        })
    }



    // Stagee //
    setStage(stage) {
        this.stage.runningDeltastageSum = Delta.copyDeltastageSum(this.runningDeltastageSum)
        this.previousStages.push(this.stage)
        if(this.previousStages.length > 10) {
            this.previousStages.shift()
        }

        this.stage = stage
    }
    saveStage() {
        const omegastage = Stage.copy(this.stage)
        omegastage.steps = []
        this.setStage(omegastage)
    }
    recalculateStage() {
        Stage.calculateActions(this.stage, {"force": true})
    }
    clearPreviousStages() {
        this.previousStages = []
    }
    reloadStage(options) {
        options = options || {}
        let protogame = games[this.gamekey]
        let protochapter = protogame.chapters[this.key]
        this.stage = Stage.load({
            "stage": protochapter.stage,
            "player": options.player || protogame.player,
            "chapterParty": protogame.chapterParty,
            "hasPreparePhase": protochapter.hasPreparePhase,
            "startingEncounter": this.stage.currentEncounterKey,
            "random": this.random,
        })
        this.recalculateStage()
        this.actionTrace = []
        this.runningDeltastageSum = {}
    }
    sumSteps(steps) {
        const subsum = {}
        steps.forEach((step) => {
            if(step.name == "SavestateCapture") return
            if(step.deltastages.length > 0) {
                Delta.addDeltastages(subsum, step.deltastages)
            }
        })
        Delta.addDeltastages(this.runningDeltastageSubsum, subsum)
        Delta.addDeltastages(this.runningDeltastageSum, subsum)
        return subsum
    }

    // User Actions //

    killAllEnemies() {
        this.saveStage()

        let currentZone = this.stage.encounters[this.stage.currentEncounterKey]
        const alliedUnits = Object.values(this.stage.units).filter((unit) => {
            return Geometry.isInBounds(currentZone, unit.position)
                && unit.affiliation == this.stage.player.affiliation
        })
        const enemyUnits = Object.values(this.stage.units).filter((unit) => {
            if(Geometry.isInBounds(currentZone, unit.position)) {
                if(unit.affiliation != this.stage.player.affiliation) {
                    return true
                }
            }
            return false
        })

        const EXPERIENCE_PER_KILL = 10
        const step = Step.instantiate({
            "alphastage": this.stage,
            "deltastages": enemyUnits.map((unit, index) => {
                const slayerUnit = alliedUnits[0]
                alliedUnits.unshift(alliedUnits.pop())

                if(slayerUnit == undefined) return

                unit.health = 0
                unit.isDead = true
                slayerUnit.experience += EXPERIENCE_PER_KILL

                return {
                    "stage": {
                        "units": [
                            {
                                "key": unit.key,
                                "isDead": true,
                                "health": 0,
                            },
                            {
                                "key": slayerUnit.key,
                                "experience": slayerUnit.experience + EXPERIENCE_PER_KILL,
                            }
                        ]
                    }
                }
            })
        })
        // this.sequence = {"steps": [step]}
        App.sequence = {"steps": [step]}
        Stage.calculateActions(step.omegastage)
        this.setStage(step.omegastage)

        this.recalculateStage()
        this.sumSteps([step])

        Navigation.state.escape = undefined
    }
    undoAction() {
        if(this.previousStages.length > 0) {
            const poppedStage = this.previousStages.pop()
            this.runningDeltastageSum = poppedStage.runningDeltastageSum
            this.stage = poppedStage

            // If we are also recording the
            // actions for a test snapshot, then
            // make sure we undo here as well.
            // TODO: read the protoactions from
            // our previousStages list?
            if(window.fae != undefined
            && window.fae.test != undefined
            && window.fae.test.snapshot != undefined) {
                window.fae.test.snapshot.protoactions.pop()

                // TODO: What happens if we undo before
                // the snapshot.alphastage? All following
                // protoactions wouldn't make any sense.
            }

            Audiomix.trigger("UndoAction")
            // if(this.selection.canSelect(this.selection.selectedUnitKey, this.stage) == false) {
            //     this.selection.reset()
            // }
            this.selection.reset()

            // this.sequence = undefined
            App.sequence = undefined
        }
    }
    performAction(action) {
        // if(window.fae != undefined
        // && window.fae.test != undefined
        // && window.fae.test.snapshot != undefined) {
        //     window.fae.test.snapshot.protoactions.push({
        //         "unitKey": action.performerKey,
        //         "position": Geometry.copy(action.position),
        //         "actionKey": action.key,
        //     })
        // }

        // this.sequence = {"steps": action.steps}
        App.sequence = {"steps": action.steps}
        action.steps.push({
            "deltastages": [],
            "omegastage": action.omegastage,
            "func": function() {
                Stage.calculateActions(action.omegastage)
            }
        })
        // Stage.calculateActions(action.omegastage) // this lags - needs to be in other thread!!!
        // action.omegastage.steps = steps
        this.setStage(action.omegastage)

        // Auto-finishing
        if(this.hasAutoEnd === true
        || this.hasUndoEndTurnButtons === false) {
            const hasFinishedTurn = Object.values(action.omegastage.units).filter((unit) => {
                if(unit.affiliation != App.game.chapter.stage.player.affiliation) return false
                if(unit.isDead == true) return false
                if(unit.isRemoved == true) return false
                if(Geometry.isOutOfBounds(action.alphastage.encounters[action.alphastage.currentEncounterKey], unit.position)) return false
                // if(unit.subclasses != undefined) {
                //     return unit.energy[1] != false
                //         || unit.energy[2] != false
                // } else {
                //     return unit.energy[1] != false
                // }
                if(unit.energy["act"] == false
                && unit.energy["move"] == false) {
                    return false
                }
                return true
            }).length == 0
            if(hasFinishedTurn == true) {
                return this.endPlayerTurn(action.omegastage)
            }
        }

        return action.omegastage
    }
    endPlayerTurn(stage, options) {
        stage = stage || this.stage
        options = options || {}

        Audiomix.trigger("EndTurn")

        // if(stage.turn.affiliation != this.player.affiliation) {
        //     return console.error("not currently player turn.")
        // }

        this.selection.reset()
        const seed = options.seed || nanoid()
        this.random.setSeed(seed)

        // And now.. perform the next turn!!

        if(stage.nextTurn == undefined) {
            Stage.calculateNextTurn(stage)
        }

        const steps = stage.nextTurn.steps
        // this.sequence = {"steps": (this.sequence?.steps || []).concat(steps)}
        // App.sequence = {"steps": (this.sequence?.steps || []).concat(steps)}
        App.sequence = {"steps": steps}

        const omegastage = steps[steps.length - 1].omegastage
        omegastage.steps = steps
        Stage.calculateActions(omegastage || this.stage)
        this.setStage(omegastage)
        this.clearPreviousStages()

        options.isAutocapturingSavestates = options.isAutocapturingSavestates || true
        if(options.isAutocapturingSavestates == true) {
            steps.forEach((step) => {
                if(step.name == "SavestateCapture") {
                    Dev.recordSavestate(step.savestateSlug, step.data)
                }
            })
        }
        this.sumSteps(stage.nextTurn.steps)
        if(options.isAutocapturingSavestates == true) {
            Dev.recordSavestate("livePlaytest")
        }

        return omegastage
    }
}
